// export const ADD = 'entities/skill/ADD';
export const ADD_MULTIPLE = 'entities/skill/ADD_MULTIPLE';
// export const UPDATE = 'entities/skill/UPDATE';
// export const REMOVE = 'entities/skill/REMOVE';
